export default {"src":"/_next/static/media/inline-skeeleren.159ecacb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};